export function generateHtmlSnapshot(
  element = document.documentElement
): string {
  // Clone the element
  let el = element.cloneNode(true) as HTMLElement;

  // Remove JS
  el.querySelectorAll('script').forEach((script) => {
    script?.parentElement?.removeChild(script);
  });

  let host = window.location.origin;
  let pathName = window.location.pathname;

  // Ensure CSS paths & images are absolute
  el.querySelectorAll('img').forEach((img) => {
    let src = img.getAttribute('src') || '';
    let newSrc = fixPath(src, { host, pathName });

    if (newSrc) {
      img.setAttribute('src', newSrc);
    }
  });

  el.querySelectorAll('link[rel="stylesheet"]').forEach((linkRel) => {
    let href = linkRel.getAttribute('href') || '';
    let newHref = fixPath(href, { host, pathName });

    if (newHref) {
      linkRel.setAttribute('href', newHref);
      linkRel.removeAttribute('integrity');
    }

    linkRel.removeAttribute('integrity');
  });

  // Convert all canvases to images
  el.querySelectorAll('canvas').forEach((canvas) => {
    let img = document.createElement('img');
    img.src = (canvas as HTMLCanvasElement).toDataURL('image/png');
    canvas?.parentNode?.replaceChild(img, canvas);
  });

  // Create a temporary element to hold the cloned HTML
  let tempDiv = document.createElement('div');
  tempDiv.appendChild(el);

  return tempDiv.innerHTML;
}

function fixPath(
  path: string,
  { host, pathName }: { host: string; pathName: string }
): string | null {
  if (path.startsWith('http')) {
    return null;
  }

  return path.startsWith('/') ? `${host}${path}` : `${host}${pathName}/${path}`;
}
